<template>
    <div class="integration-wrap">
        <input type="text" placeholder="Type to search..." v-model="search" class="main-search-input">
        <div class="integration-items" v-if="Object.keys(includedData).length">
            <IntegrationItem
                v-for="(item, index) in filteredList"
                :class="{active: includedData[item.id].attributes.active}"
                @click="selectItem(item.id)"
                @changeActiveItem="changeActiveItem"
                :key="item.id"
                :item="item"
                :includedData="includedData"
            />
        </div>
    </div>
</template>

<script>
import IntegrationItem from "@/components/automation-parts/IntegrationItem.vue"
import {mapGetters} from "vuex"

export default {
  name: "Step2",
  components: {
      IntegrationItem,
  },
  props: ['integrations', 'data'],
  data() {
      return {
          search: "",
          selected: false,
          includedData: {}
      }
  },
    computed: {
        ...mapGetters(["getIntegrationItems"]),
        filteredList() {
            if(this.integrations) {
                return this.integrations.filter(item => {
                    return item.attributes.caption.toLowerCase().includes(this.search.toLowerCase())
                })
            } return []
        },
    },
    methods: {
        selectItem(id) {
            if(this.includedData[id].attributes.active) {
                this.$emit('done', id);
                this.$store.commit("selectIntegration", id)
            }
        },
        changeActiveItem(item, included) {
            this.$store.commit("showActivateAutomationPopup")
            this.$store.commit("detectCurrentIntegration", {item, included})
        },
    },
    beforeMount() {
        this.integrations.data.forEach(item => {
            var target = this.integrations.included.find(inc => inc.id === item.id);
            if(target) {
                this.includedData[item.id] = target;
            }
        });
    }
}
</script>

<style lang="scss">
.integration-wrap .item img {
    display: block;
    height: 40px;
    width: auto;
    max-width: 100%;
    object-fit: contain;
    object-position: center;
    margin: 0 auto;
}
</style>
